import type { ReactNode } from 'react';

interface SettingsRowProps {
    label: string;
    description?: string;
    control: ReactNode;
    controlId?: string;
}

export default function SettingsRow({ label, description, control, controlId }: SettingsRowProps) {
    const descriptionId = controlId ? `${controlId}-description` : undefined;

    return (
        <div className="flex items-start justify-between gap-4 px-4 py-3.5">
            <div className="min-w-0 flex-1">
                <label
                    htmlFor={controlId}
                    className="text-sm font-medium text-[#1e293b] block"
                >
                    {label}
                </label>
                {description && (
                    <p
                        id={descriptionId}
                        className="text-xs text-[#64748b] mt-0.5 leading-relaxed"
                    >
                        {description}
                    </p>
                )}
            </div>
            <div
                className="flex-shrink-0 pt-0.5"
                aria-describedby={descriptionId}
            >
                {control}
            </div>
        </div>
    );
}
